import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

function Header() {
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Calculators', path: '/calculators' },
    { name: 'Articles', path: '/articles' },
    { name: 'About Us', path: '/aboutus' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#050805]/80 backdrop-blur-md border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link to="/" className="text-brand font-bold text-xl tracking-tighter flex items-center gap-2">
            <div className="w-6 h-6 bg-brand rounded-sm flex items-center justify-center">
              <div className="w-3 h-3 bg-[#050805] rounded-[1px]" />
            </div>
            CalcBlog
          </Link>
          <div className="hidden md:flex items-center gap-6 text-sm font-medium text-slate-400">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                className={`transition-colors hover:text-brand ${location.pathname === link.path
                  ? 'text-brand border-b border-brand pb-0.5'
                  : ''
                  }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
        <button className="bg-brand/10 hover:bg-brand/20 text-brand px-4 py-1.5 rounded-full text-xs font-semibold border border-brand/20 transition-all">
          Initialize Node
        </button>
      </div>
    </nav>
  );
}

export default Header;